import React from "react";
import { withRouter } from "react-router-dom";
import "@ied/ui-core/dist/ui-core.min.css";
import "@ied/ui-select/dist/ui-select.min.css";
import "@ied/ui-list/dist/ui-list.min.css";
import "@ied/ui-menu/dist/ui-menu.min.css";
import Select from "@ied/ui-select";
import { SelectContainer } from "./Styled";

const Header = ({ setStateLang, lang }) => (
  <header className="header">
    <div>
      <h1 style={{ lineHeight: 0 }}>
        <a
          className="logo"
          href="https://portal.deloitte.direct/"
          title="Deloitte Direct"
        >
          Deloitte Direct
        </a>
      </h1>
    </div>
    <SelectContainer>
      <Select
        fullwidth
        outlined
        color="white-500"
        icon="language"
        value={lang || ""}
        onChange={(evt) => setStateLang(evt.target.value)}
        options={[
          {
            label: "AT-DE",
            value: "at",
          },
          {
            label: "DK-DA",
            value: "da",
          },
          {
            label: "EN-GB",
            value: "en",
          },
        ]}
      />
    </SelectContainer>
  </header>
);

export default withRouter(Header);
